import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Button, InlineTextButton, Modal } from '../../components';
import { useHistory } from 'react-router-dom';

import css from './MissingInfoModal.module.css';

const MissingInfoModal = props => {
    const {
        isMissingInfoModalOpen,
        setIsMissingInfoModalOpen,
        onManageDisableScrolling,
        setIsProfileModalOpen,
        isFromCreateListing
    } = props;

     const history = useHistory();
        const handleDoItLaterClick = () => {
        setIsMissingInfoModalOpen(false);
        if (isFromCreateListing) {
            history.goBack();
        }
    };

    return (
        <Modal
            id="MissingInfoModal"
            containerClassName={css.missingInformationModal}
            isOpen={isMissingInfoModalOpen}
            onClose={() => { setIsMissingInfoModalOpen(false) }}
            hideCloseBtn={true}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
        // closeButtonMessage={closeButtonMessage}
        >
            <div className={css.container}>
                <p className={css.modalTitle}>
                    <FormattedMessage id="ModalMissingInformation.MissingInfoReminderTitle" />
                </p>
                <p className={css.modalMessage}>
                    <FormattedMessage id="ModalMissingInformation.MissingInfoReminderText" />
                </p>
                <Button className={css.actionButton}
                    onClick={() => {
                        setIsMissingInfoModalOpen(false);
                        setIsProfileModalOpen(true);
                    }}>
                    <FormattedMessage id="ModalMissingInformation.MissingInfoReminderButton" />
                </Button>
                <InlineTextButton className={css.closemodalButton} onClick={handleDoItLaterClick}>
                    <FormattedMessage id="ModalMissingInformation.DoItLater" />
                </InlineTextButton>
            </div>
        </Modal>
    );
};

export default MissingInfoModal;
